import React, { Component } from "react";
import TableHeader from './TableHeader.jsx';
import TableBody from './TableBody.jsx';
import TableFooter from './TableFooter.jsx';

class Table extends Component {
    constructor(props) { super(props); }

    render() {
        
        return (
            <div className="bottom-separator-xxs">
                <TableHeader limitesCliente={this.props.limitesCliente} />

                <hr className="separator-line separator-light" />

                <TableBody
                    data={this.props.data}
                    internalData={this.props.internalData}
                    updateLimitsFunction={this.props.updateLimitsFunction}
                    editNotifyFn={this.props.editNotifyFn}
                    functions={this.props.functions}
                    aparicionLapizEdicion={this.props.aparicionLapizEdicion}
                    comienzoDeEdicion={this.props.comienzoDeEdicion}
                    desaparicionLapizEdicion={this.props.desaparicionLapizEdicion}
                    cancelEdicionLimite={this.props.cancelEdicionLimite}
                    cancelEdicionNovedad={this.props.cancelEdicionNovedad}
                    aceptarEdicion={this.props.aceptarEdicion}
                    modificacionLimite={this.props.modificacionLimite}
                    modificacionNovedad={this.props.modificacionNovedad}
                    muestraEditadoNovedad={this.props.muestraEditadoNovedad}
                    ocultaEditadoNovedad={this.props.ocultaEditadoNovedad} />

                <hr className="separator-line separator-light" />

                <TableFooter limitesCliente={this.props.limitesCliente}  />
            </div>
        );
    }
}

export default Table;